<router-outlet></router-outlet>
<ngx-spinner type="Loading">
  <p style="color: white">Loading...</p>
</ngx-spinner>
